import { action, Action } from 'easy-peasy';
import { NewAskerInfo } from '@/services/space/types';

export interface IAskerInfoModel {
    newAskerList: NewAskerInfo[];
    setNewAskerList: Action<IAskerInfoModel, NewAskerInfo[]>;
    hasAskerUnread: boolean;
    setHasAskerUnread: Action<IAskerInfoModel, boolean>;
    showAllAskers: boolean;
    setShowAllAskers: Action<IAskerInfoModel, boolean>;
    // 关闭消息弹窗
    destroyNotifyModal: Action<IAskerInfoModel>;
    // 隐藏消息提示红点同时关闭消息弹窗
    destroyNotifyDot: Action<IAskerInfoModel>;
}

export const askerInfoModel: IAskerInfoModel = {
    newAskerList: [],
    setNewAskerList: action((state, payload) => {
        state.newAskerList = payload;
    }),
    hasAskerUnread: false,
    setHasAskerUnread: action((state, payload) => {
        state.hasAskerUnread = payload;
    }),
    showAllAskers: false,
    setShowAllAskers: action((state, payload) => {
        state.showAllAskers = payload;
    }),
    destroyNotifyModal: action((state) => {
        state.newAskerList = [];
    }),
    destroyNotifyDot: action((state) => {
        state.hasAskerUnread = false;
        state.newAskerList = [];
    }),
};
